module.exports = __webpack_public_path__ + "static/media/r430.a346b3ba.jpg";